<script lang="ts">
  export const name = 'Square';
  export let className = '';
</script>

<svg class="fill-current stroke-current {className}" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
  <rect x="42.5" y="42.5" width="115" height="115" rx="6.5" fill="none" stroke-width="10" />
</svg>
